import PopupBasic from 'src/game/components/popups/PopupBasic';
import View from '@play-co/timestep-core/lib/ui/View';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import bitmapFonts from 'src/lib/bitmapFonts';
import i18n from 'src/lib/i18n/i18n';
import ScrollView from '@play-co/timestep-core/lib/ui/ScrollView';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import uiConfig from 'src/lib/ui/config';
import { trackToSDetails } from 'src/lib/analytics/events';
import sounds from 'src/lib/sounds';

export default class PopupTermsPolicyDetails extends PopupBasic {
  private container: ScrollView;
  private text: LangBitmapFontTextView;
  private cta: ButtonScaleViewWithText;

  constructor(private creationOpts: { superview: View; close: () => void }) {
    super({
      ...creationOpts,
      height: 800,
      width: 560,
      skipMessage: true,
      darkerBg: true,
      tracking: { feature: 'terms', $subFeature: 'popup-terms-policy-details' },
    });

    this.root.updateOpts({ zIndex: 10005 });
    this.bg.updateOpts({ opacity: 0.95 });
    this.buttonClose.hide();

    // create scrollable container
    this.container = new ScrollView({
      superview: this.box,
      x: 20,
      width: 520,
      height: 594,
      y: 80,
      scrollX: false,
      scrollY: true,
    });

    this.text = new LangBitmapFontTextView({
      superview: this.container,
      width: 520,
      align: 'left',
      y: 8,
      //verticalAlign: 'center',
      size: 24,
      color: '#9A7171',
      wordWrap: true,
      forceWrap: true,
      // Use slightly smaller font for the long text
      font: bitmapFonts('Body'),
      isRichText: true,
    });

    // OKAY button
    this.cta = new ButtonScaleViewWithText({
      ...uiConfig.buttons.secondary,
      superview: this.box,
      labelOffsetY: -1,
      fontSize: 40,
      font: bitmapFonts('Body'),
      x: this.box.style.width / 2,
      y: this.box.style.height - 70,
      width: 240,
      height: 78,
      centerOnOrigin: true,
      onClick: async () => {
        sounds.playSound('ok');
        creationOpts.close();
      },
      tracking: {
        feature: 'terms',
        $subFeature: 'popup-terms-policy-details-ok',
      },
    });
  }

  init({ mode }: { mode: 'pp' | 'tos' }) {
    super.init({
      title: i18n(
        mode === 'pp'
          ? 'platform.line.terms.pp.title'
          : 'platform.line.terms.tos.title',
      ),
    });

    trackToSDetails({ mode });

    this.text.localeText = () =>
      i18n(
        mode === 'pp'
          ? 'platform.line.terms.pp.content'
          : 'platform.line.terms.tos.content',
      );

    // set scroll bounds
    this.container.updateOpts({
      scrollBounds: {
        minY: 0,
        maxY: this.text.getTextHeight() + 50,
      },
    });

    this.cta.localeText = () =>
      i18n(
        mode === 'pp'
          ? 'platform.line.terms.pp.cta'
          : 'platform.line.terms.tos.cta',
      );
  }
}
